document.addEventListener('click', function (e) {
  var btn = e.target.closest('.acc-btn');
  if (!btn) return;
  var panel = document.getElementById(btn.getAttribute('aria-controls'));
  if (!panel) return;
  var open = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!open));
  panel.hidden = open;
  var sign = btn.querySelector('.sign');
  if (sign) sign.textContent = open ? '+' : '\u2212';
});

(function () {
  var form = document.querySelector('[data-variant-form]');
  if (!form) return;
  var data = document.getElementById('variant-data');
  if (!data) return;
  var variants = JSON.parse(data.textContent);
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.getElementById('pdp-price');
  var stockEl = document.getElementById('stockline');
  var submits = document.querySelectorAll('[data-submit]');
  var money = form.getAttribute('data-money') || '${{amount}}';

  function fmt(cents) {
    return money.replace('{{amount}}', (cents / 100).toFixed(2));
  }

  function select(id) {
    var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!v) return;
    idInput.value = v.id;
    if (priceEl) {
      priceEl.innerHTML = fmt(v.price) + (v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price) + '</s>' : '');
    }
    if (stockEl) {
      stockEl.textContent = !v.available
        ? 'Sold out in this option'
        : (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5)
          ? 'Only ' + v.inventory_quantity + ' left in ' + v.title
          : 'In stock';
    }
    submits.forEach(function (b) {
      b.disabled = !v.available;
      b.innerHTML = v.available
        ? 'Add to cart \u2014 ' + fmt(v.price) + '<small>' + (form.getAttribute('data-ship') || '') + '</small>'
        : 'Sold out<small>Pick another option</small>';
    });
    form.querySelectorAll('.opt').forEach(function (b) {
      b.setAttribute('aria-pressed', String(String(b.dataset.variantId) === String(v.id)));
    });
  }

  form.querySelectorAll('.opt').forEach(function (b) {
    b.addEventListener('click', function () { select(b.dataset.variantId); });
  });

  var initial = form.querySelector('.opt[aria-pressed="true"]');
  if (initial) select(initial.dataset.variantId);

  var bar = document.getElementById('buybar');
  var inline = document.getElementById('inline-cta');
  if (bar && inline && 'IntersectionObserver' in window) {
    bar.hidden = false;
    new IntersectionObserver(function (entries) {
      bar.style.display = entries[0].isIntersecting ? 'none' : 'block';
    }, { threshold: 0 }).observe(inline);
  }
})();
